<template>
  <div 
  class="relative flex items-center lh-1 custom-checkbox" 
  :class="`${classCustom ? classCustom : isAlignCenter ? 'mb-0': 'mb-16'}`"
  >
    <input
      type="checkbox"
      class="hand w-16 h-16 absolute left-0 o-0"
      :id="id"
      :name="name"
      :value="value"
      :checked="isChecked"
      v-model="getValue"
    />
    <label class="dib hand pl-28" :for="id">
      <span class="dib lh-1 fs-14 lh-17 gray-dark">{{ label }}</span>
    </label>
  </div>
</template>

<script>
import { computed, defineComponent, onMounted } from 'vue'

export default defineComponent({
  name: 'CheckBox',
  props: {
    id: { type: String, default: '', require: true },
    name: { type: String, default: '', require: true },
    classCustom: { type: String, default: '' },
    value: { type: [String, Number], require: true },
    label: { type: String, default: '', require: true },
    modelValue: { type: [Array, Object, Boolean, Number], default: null },
    isChecked: { type: Boolean, default: false },
    isAlignCenter: { type: Boolean, default: false },
  },
  emits: ['update:modelValue', 'trigger'],
  setup(props, { emit }) {
    const getValue = computed({
      get: () => props.modelValue,

      set: (value) => {
        emit('update:modelValue', value)
        emit('trigger', value)
      },
    })

    const initChecked = () => {
      if (props.isChecked) getValue.value.push(props.value)
    }

    onMounted(() => {
      initChecked()
    })

    return { getValue }
  },
})
</script>

<style lang="scss" scoped>
.custom-checkbox {
  input[type='checkbox'] {
  }
  label {
    &::after,
    &::before {
      position: absolute;
      left: 0;
      top: 0;
      display: block;
      width: 16px;
      height: 16px;
      content: '';
      transition: all 0.15s ease-in-out;
      border-radius: 3px;
    }
    &::before {
      pointer-events: none;
      border: 1px solid $gray-medium;
    }
    &::after {
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  input:checked ~ label {
    &::after {
      // background-color: $blue-branding-600;
      background-color: brandColor(brand,800);
      background-image: url('https://s3-cdn.designerjourneys.com/static/icons/icon-mask.svg');
    }
  }
  input:hover ~ label,
  label:hover {
    &::before {
      border-color: $blue-branding;
      background-color: $blue-branding-80;
    }
  }
}
</style>
